import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class AgentStreamEventModel {
    static fromDTO(dto) {
        const validTypes = [
            'tool-call-start',
            'tool-call-end',
            'thinking',
            'message',
            'error',
            'draft-created',
            'message-enrichment',
            'ack',
            'reset'
        ];
        if (!validTypes.includes(dto.type)) {
            throw new Error("unknown AgentStreamEvent type: ".concat(dto.type));
        }
        return new AgentStreamEventModel(dto);
    }
    match(handlers) {
        const d = this.dto;
        switch(d.type){
            case 'tool-call-start':
                return handlers.toolCallStart(d.tool, d.args);
            case 'tool-call-end':
                return handlers.toolCallEnd(d.tool, d.durationMs);
            case 'thinking':
                return handlers.thinking(d.text);
            case 'message':
                return handlers.assistantMessage(d.message);
            case 'error':
                return handlers.streamError(d.error);
            case 'draft-created':
                return handlers.draftCreated(d.draftId);
            case 'message-enrichment':
                return handlers.messageEnrichment(d.messageId, d.contentPatch);
            case 'ack':
                return handlers.ack(d.text);
            case 'reset':
                return handlers.reset();
        }
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
